exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/Finca/Finca UI/UI/node_modules/css-loader?{"sourceMap":false,"import":false}!D:/Finca/Finca UI/UI/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/Finca/Finca UI/UI/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!D:/Finca/Finca UI/UI/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles